/**
 * Вкладка «Шаблоны» — каталог партнёра целиком.
 *
 * Сам список живёт в `TemplateCatalog.tsx` и используется ещё и панелью
 * набора на вкладке «Уровни». Здесь остались только рамка и подпись:
 * второй копии правил «что показывать» и «что выбирается» в разделе нет
 * намеренно — они однажды разошлись бы, и панель показывала бы не то, что
 * эта вкладка.
 */

import { Card } from '../../components/ui.js'
import { TemplateCatalog } from './TemplateCatalog.js'

export function Templates(): JSX.Element {
  return (
    <Card
      title="Шаблоны партнёра"
      hint="Шаблоны с «нужен промпт» показаны, но в набор уровня не выбираются."
    >
      <TemplateCatalog />
    </Card>
  )
}
